import { Row, Radio, Form, Input } from "antd";
import { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { update_icebt_form } from "../../actions/form_slice";
import { debounce } from "lodash";

const ICEBT = forwardRef(({ onValuesChange }, ref) => {
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    getFieldsError: form.getFieldsError,
    validateFields: form.validateFields,
    resetFields: form.resetFields,
    setFieldsValue: form.setFieldsValue,
    submit: form.submit,
    getFieldsValue: form.getFieldsValue,
  }));

  const dispatch = useDispatch();
  const formData = useSelector((state) => state.form.icebt_form_type);

  const handleFormChange = debounce((changedValues) => {
    dispatch(update_icebt_form(changedValues));
    onValuesChange(formData);
  }, 300);
  return (
    <Form
      form={form}
      onValuesChange={handleFormChange}
      // onFinish={props.onFinish}
      labelAlign="justify"
      layout="horizontal"
      labelWrap
      //   wrapperCol={{
      //     flex: 1,
      //   }}
    >
      <Form.Item
        name="Do you have Kansas Benefits Card?"
        label="Do you have Kansas Benefits Card?"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Radio.Group>
          <Radio value="yes">Yes</Radio>
          <Radio value="no">No</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item name="Comments" label="Comments">
        <Input style={{ width: "100%" }} />
      </Form.Item>
      <Row>
        <label>
          If No- Check EBTEdge, new cards will not be mailed if an existing
          “acive” status is showing.
        </label>
      </Row>
      <Row>
        <label>FIS Customer Service # 1-800-997-6666</label>
      </Row>
    </Form>
  );
});
export default ICEBT;
